var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _ellipse, _ellipse2, _path39, _ellipse3, _ellipse4, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "840px",
    height: "1010px",
    viewBox: "0 0 840 1010",
    style: {
      enableBackground: "new 0 0 840 1010"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.08,455.46c20.67-3.9,41.68-6.03,62.72-6.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.72,444.52c24.06-5.31,48.96-6.86,73.49-4.57c0.35,8.91-0.36,17.86-2.11,26.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.61,468.28c1.03,36.57,2.97,73.11,5.82,109.57c59-9.94,119.19-12.78,178.86-8.43 c4.15,0.3,8.72,0.52,12.01-2.02c4.75-3.66,4.31-10.83,3.41-16.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.61,246.24c-4.37-14.86-7.26-30.15-8.6-45.58c-0.65-7.46-0.85-15.36,2.6-22 c5.32-10.21,17.87-14.56,29.39-14.73c3.05-0.04,6.95,0.87,7.35,3.89c0.28,2.16-1.64,4.07-3.71,4.72c-2.08,0.65-4.31,0.42-6.48,0.54 c-6.67,0.35-13.05,4.22-16.44,9.97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.03,174.12c3.96-0.58,8.15,0.54,11.29,3.02c0.76,0.6,1.52,1.4,1.52,2.37c0,0.86-0.63,1.63-1.39,2.04 c-0.76,0.41-1.64,0.52-2.5,0.61c-3.51,0.37-7.08,0.44-10.5,1.31c-3.42,0.87-6.78,2.68-8.6,5.71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.41,182.97c3.98-1.24,8.41-0.97,12.2,0.77c1.56,0.71,3.23,2.21,2.67,3.83c-0.56,1.63-2.77,1.76-4.5,1.69 c-4.02-0.17-8.17,0.22-11.79,1.97c-3.63,1.74-6.68,5.02-7.4,8.98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.44,190.14c2.25-0.25,4.54-0.15,6.76,0.3c1.19,0.24,2.41,0.6,3.35,1.37c0.94,0.77,1.57,2.04,1.27,3.22 c-0.44,1.76-2.5,2.5-4.27,2.91c-2.98,0.7-5.99,1.33-8.83,2.49c-2.83,1.16-5.51,2.9-7.25,5.41c-1.95,2.82-2.56,6.31-3.68,9.55 s-3.14,6.55-6.43,7.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.07,219.24c0.36,1.27,0.72,2.54,1.08,3.81c1,3.53,2,7.08,2.38,10.73c0.38,3.65,0.09,7.44-1.39,10.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.23,255.11c20.8-5.85,42.5-8.51,64.1-7.85c0.18,33.91,9.16,67.73,25.84,97.25 c8.81,15.6,19.91,30.19,34.26,40.92s32.2,17.38,50.08,16.22c17.88-1.15,35.53-10.79,45.64-26.82 c13.08-18.53,20.44-40.48,25.76-62.52s8.8-44.53,15.02-66.34c1.18-4.12,2.74-8.58,6.44-10.74c3.71-2.16,8.36-1.3,12.54-0.39 c13.64,2.99,27.27,5.97,40.91,8.96"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.58,233.3c-4.37-5.9-4.58-14.56-0.5-20.67c1.87-2.8,4.48-5.01,6.63-7.61c2.15-2.59,3.88-5.84,3.46-9.18 c-0.32-2.56-1.85-4.77-3.2-6.97c-1.34-2.2-2.58-4.69-2.22-7.24s3.03-4.89,5.43-3.97c1.39,0.53,2.24,1.92,2.99,3.21 c2.9,5.03,5.8,10.06,8.7,15.09"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.68,178.2c-0.63-1.49-1.28-3.06-1.13-4.68c0.14-1.61,1.36-3.26,2.99-3.28c0.89-0.01,1.73,0.46,2.43,1.01 c2.88,2.25,4.27,5.85,5.77,9.18c1.98,4.39,4.37,8.59,7.13,12.54"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.1,172.64c-0.22-1.44-0.43-2.92-0.14-4.35c0.3-1.43,1.21-2.82,2.61-3.26c1.38-0.44,2.88,0.14,4.11,0.91 c3.99,2.49,6.36,6.85,8.42,11.08c2.06,4.23,4.08,8.68,7.71,11.68c0.89,0.74,1.94,1.4,3.09,1.4c1.32,0.01,2.48-0.83,3.51-1.66 c2.85-2.33,5.46-4.95,7.76-7.82c0.71-0.88,1.41-1.81,2.35-2.44c0.94-0.63,2.2-0.92,3.22-0.43c1.53,0.74,1.85,2.77,1.75,4.47 c-0.32,5.86-3.23,11.54-7.8,15.23c-6.72,5.43-16.39,6.46-22.52,12.56c-2.95,2.93-4.79,6.77-6.57,10.53 c-0.18,0.38-0.36,0.77-0.4,1.19c-0.07,0.77,0.34,1.49,0.61,2.21c0.95,2.57-0.1,5.73-2.39,7.23"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.08,163.5c-7.51-36.45-12.05-73.51-15.82-108.96c93.23-15.9,189.31,5.32,286.44-2.77 c2.88,16.65,3.85,33.63,2.88,50.5c-0.75,13.16-2.67,26.21-4.59,39.25c-1.17,7.97-2.34,15.93-3.52,23.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.57,209.27c65.04-4.5,130.24-6.6,195.43-6.3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.28,261.2c7.48,38.69,24.07,75.16,44.55,108.83s44.86,64.77,69.18,95.78"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.84,458.11c-9.3,29.37-11.93,60.83-7.65,91.33"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.99,253.94c-2.35,43.37-14.41,86.19-35.04,124.41c-16.49,30.56-38.56,58.68-52.49,86.93 c-3.51,13.98-1.26,29.32,6.13,41.71c4.9,8.23,12.16,15.73,12.98,25.28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.93,545.27c43.68-11.95,89.14-15.35,133.81-10"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.52,917.94c-0.13,0.79-0.25,1.57-0.38,2.36c-10.93,2.9-21.58,6.86-31.75,11.81 c-1.36,0.66-2.9,1.59-3.05,3.1c-0.13,1.31,0.92,2.5,2.15,2.97c1.23,0.47,2.59,0.39,3.9,0.3c13.97-0.96,27.94-1.91,41.9-2.87 c4.9-0.34,10.05-0.75,14.14-3.48c6.18-4.13,8.1-12.19,9.53-19.48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.84,917.47c0.13,0.79,0.25,1.57,0.38,2.36c10.93,2.9,21.58,6.86,31.75,11.81c1.36,0.66,2.9,1.59,3.05,3.1 c0.13,1.31-0.92,2.5-2.15,2.97c-1.23,0.47-2.59,0.39-3.9,0.3c-13.97-0.96-27.94-1.91-41.9-2.87c-4.9-0.34-10.05-0.75-14.14-3.48 c-6.18-4.13-8.1-12.19-9.53-19.48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.34,386.24c1.57,4.88-0.46,10.27-3.59,14.33c-3.13,4.06-7.28,7.19-10.83,10.89 c-5.64,5.87-9.76,13.19-11.84,21.06c-1.16,4.39-1.54,9.52,1.31,13.05c2.59,3.21,7.08,4.13,11.2,4.31 c7.63,0.33,15.34-1.17,22.29-4.35c4.62,5.85,11.81,9.58,19.25,9.99s15-2.52,20.22-7.83"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.41,283.61c5.98-19.06,21.41-34.78,40.15-40.92s40.31-2.55,56.13,9.36c10.5-16.6,33.84-21.86,51.8-14.36 c17.97,7.5,30.35,25.47,34.91,44.65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.6,309.97c13.06,5.03,29.06,1.13,38.33-9.36c2.97-3.36,5.59-7.51,9.86-8.88 c4.91-1.57,10.02,1.12,14.85,2.95c14.8,5.59,32.5,2.69,44.74-7.34c11.99,11.98,30.08,17.48,46.71,14.22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.14,306.82c4.71,20.63,4.21,43.23-6.6,61.62c-10.8,18.39-33.58,31.11-55,26.39 c-17.35-3.82-30.64-17.99-37.56-33.76c-6.92-15.77-8.49-33.15-9.97-50.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.72,390.46c9.02,16.69,18.03,33.37,27.05,50.06c2.04,3.78,4.04,8.59,1.53,12.07 c-1.86,2.57-5.54,3.16-8.63,2.45c-3.09-0.71-5.83-2.45-8.72-3.76c-7.67-3.48-16.69-3.9-24.65-1.15c-4.06,1.4-7.84,3.59-12,4.69 c-4.15,1.1-9.01,0.93-12.21-1.94"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.37,415.84c-7.4-1.51-14.98-3.02-22.46-1.97c-7.48,1.05-14.98,5.16-18.01,12.09 c-2.33,5.33-1.73,11.44-0.91,17.21c0.63,4.36,1.36,8.71,2.2,13.04c0.53,2.73,1.83,6.09,4.61,6.13c1.57,0.02,2.95-1.18,3.61-2.61 c0.67-1.42,0.77-3.03,0.85-4.6c0.44-7.81,0.89-15.61,1.33-23.42"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.85,448.77c-0.01,4.58,1.57,9.14,4.4,12.74c0.85,1.07,2,2.14,3.36,2.02c1.8-0.17,2.7-2.23,3.15-3.98 c2.53-9.8,2.88-20.15,1.02-30.09"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527.95,453.79c0.47,1.87,0.96,3.79,1.99,5.39s2.7,2.86,4.52,2.78c1.96-0.08,3.63-1.72,4.44-3.64 c0.81-1.91,0.92-4.07,0.98-6.17c0.2-6.79-0.02-13.59-0.65-20.35"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.9,453.84c0.19,1.79,1.09,3.41,2.3,4.12c1.21,0.72,2.68,0.51,3.76-0.52c1.44-1.38,2.02-3.9,2.4-6.25 c1.22-7.52,1.37-15.37,0.44-22.97"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.38,502.29c-7.3,1.46-14.97-0.73-21.36-4.56c-6.39-3.83-11.68-9.21-16.76-14.66 c-1.74-1.87-4.14-3.93-6.53-3.02c-2.45,0.94-2.77,4.5-1.42,6.75s3.73,3.63,5.73,5.33c2,1.7,3.78,4.2,3.19,6.76 c-0.52,2.26-2.78,3.76-5.06,4.17c-2.28,0.41-4.61-0.03-6.9-0.36c-6.72-0.95-13.53-0.87-20.31-0.78c-1.82,0.02-3.7,0.06-5.36,0.82 s-3.03,2.45-2.82,4.26c0.3,2.61,3.36,3.81,5.93,4.34c9.55,1.96,19.44,2.22,29.08,0.75"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M603.5,512.53c-2.25,2.04-2.82,5.65-1.44,8.35c1.07,2.1,3.18,3.62,5.51,4.01c3.53,0.59,7.02-1.29,10.6-1.3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M608.32,525.43c-1.94-0.31-3.71,1.75-3.54,3.71c0.17,1.96,1.84,3.55,3.71,4.16c1.87,0.61,3.91,0.39,5.84-0.02 c1.92-0.41,3.82-1.02,5.78-1.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M686.53,381.03c5.06-0.06,9.87-1.07,13.8-3.92"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.68,404.7c14.92-9.29,29.84-18.58,44.75-27.88c3.31-2.06,6.89-4.19,10.78-4c4.43,0.22,8.07,3.38,11.93,5.55 c3.18,1.79,6.6,2.93,10.14,3.66"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M628.42,556.93c23.12,14.74,51.78,17.71,79.19,17.28c5.63-0.09,11.36-0.32,16.66-2.24 c5.29-1.91,10.16-5.78,11.94-11.12s-0.38-12.09-5.53-14.37"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614.34,888.43c0.89,4.19,1.56,9.16-1.45,12.2c-1.41,1.42-3.38,2.11-5.29,2.71 c-16.34,5.16-33.61,7.34-50.72,6.41c-2.72-0.15-6.28-1.25-6.17-3.97c0.09-2.24,2.69-3.37,4.86-3.97 c10.74-2.99,21.48-5.99,32.22-8.98"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.65,278.3c-11.28,23.16-11.1,52.47,3.64,73.59c14.74,21.12,44.78,31.33,68.12,20.45 c13.78-6.43,24-19.08,29.89-33.1s7.81-29.4,8.34-44.6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M688.65,901.39c-0.89,4.19-1.56,9.16,1.45,12.2c1.41,1.42,3.38,2.11,5.29,2.71 c16.34,5.16,33.61,7.34,50.72,6.41c2.72-0.15,6.28-1.25,6.17-3.97c-0.09-2.24-2.69-3.37-4.86-3.97 c-10.74-2.99-21.48-5.99-32.22-8.98"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9912 -0.1323 0.1323 0.9912 -42.4508 33.1611)",
    className: "st0",
    cx: 228.25,
    cy: 335.95,
    rx: 23.17,
    ry: 23.58
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9912 -0.1323 0.1323 0.9912 -40.9643 40.5287)",
    className: "st0",
    cx: 284.42,
    cy: 328.45,
    rx: 23.17,
    ry: 23.58
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.35,333.87c-0.09-2.09,2.01-4.17,4.55-4.54c2.54-0.36,5.16,1.06,5.66,3.09"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.066 -0.9978 0.9978 0.066 288.2688 928.9755)",
    className: "st0",
    cx: 640.37,
    cy: 310.5,
    rx: 23.58,
    ry: 23.17
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.066 -0.9978 0.9978 0.066 337.3482 988.893)",
    className: "st0",
    cx: 696.92,
    cy: 314.24,
    rx: 23.58,
    ry: 23.17
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.43,313.03c0.33-2.06,2.79-3.69,5.36-3.55c2.57,0.15,4.84,2.05,4.94,4.15"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.15,373.2c8.41-0.77,16.71-2.78,24.55-5.95c2.01,3.15,1.32,7.52-1.02,10.43s-6.01,4.5-9.7,5.06 c-2.82,0.43-5.84,0.29-8.32-1.11C248.17,380.22,246.41,377.32,245.15,373.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M645.37,349.25c12.53,6.83,29.01,5.6,40.39-3.01"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.32,278.97c-5.62,9.89-19.04,14.48-29.54,10.11s-16.69-17.14-13.62-28.09 c3.07-10.95,14.98-18.65,26.23-16.93c2.52-11.84,11.92-21.94,23.54-25.31c11.62-3.37,24.97,0.15,33.42,8.81 c8.8-10.5,23.35-15.85,36.85-13.55s25.46,12.16,30.29,24.98c7.48-5.42,17.07-8.57,26.07-6.51c9,2.06,16.81,10.24,16.6,19.47 c-0.22,9.23-10.22,17.46-18.92,14.39c5.84,2.07,8.07,10.04,5.23,15.54c-2.84,5.5-9.38,8.36-15.57,8.26 c-6.19-0.11-12.07-2.72-17.41-5.86c-13.23,8.41-32.88,4.19-41.49-8.92c-1.45,5.31-7.53,8.16-13.04,8.04 c-5.5-0.12-10.68-2.43-15.92-4.12C634.1,274.46,618.5,275.12,616.32,278.97z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M698.75,376.61c11.05,3.48,22.16,7,32.39,12.42c10.23,5.42,19.64,12.92,25.58,22.87 c4.11,6.88,6.42,14.67,8.42,22.43c2.78,10.79,5.04,21.71,6.77,32.72"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M720.21,439.24c6.78,14.9,5.11,33.33-3.03,48.03c17.33-6.33,36.4-7.82,54.5-4.25"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.75,465.25c-0.5,5.61,0.11,11.32,1.78,16.71"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M667.42,530.53c34.67,4.08,70.7-4.8,99.51-24.5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M582.9,420.57c-9.7-1.54-19.84-0.22-28.82,3.76"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.31,409.98c3.31,6.74,6.65,13.53,11.19,19.52c4.54,5.98,10.41,11.18,21.87,12.53 c3.26-6.65,6.53-13.3,9.79-19.94"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M651.11,381.31c3.84,13.35,9.24,26.3,16.23,37.93c7.32-12.68,13.95-25.71,19.88-39.02"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.43,483.64c-8.1,10.84-22.85,14.1-36.37,14.84c-13.51,0.73-27.61-0.17-39.99,5.3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612.33,569.27c-35.04,102.61-53.5,210.86-54.47,319.29c19.61-6.19,40.55-8.14,60.97-5.68 c-2.02-71.69,9.91-143.75,36.65-210.11c13.28,74.34,17.63,150.27,15.49,226.43c22.12-4.05,44.75-5.32,67.19-3.77 c14.38-106.42-21.6-214.64-8.85-321.27"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.97,545.34c-35.47,120.15-36.36,251.99-5.19,365.96c24.79-2.91,49.85-3.16,75.82-4.36 c-0.58-83.48-1.15-166.96,4.25-249c29.66,78.02,43.81,162.9,43.9,243.83c25.66-3.89,52.11-1.53,76.84,6.85 c-2.4-125.86-22.19-251.32-58.51-370.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNew);
export default __webpack_public_path__ + "static/media/WhatsNew.0fd26b70da74b057f42fb27e68f24bb2.svg";
export { ForwardRef as ReactComponent };